import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { AppService } from '../../../../../../../../../../shared/services';

@Component({
    selector: 'app-usage-details-form',
    templateUrl: './usage-details-form.component.html',
    styleUrls: ['../../input-component-styles.scss', './usage-details-form.component.scss'],
    standalone: false
})
export class UsageDetailsFormComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup = new FormGroup({});
  @Input() selectedMediaFiles: any[] = [];
  @Input() uom: string;
  @Output() onDeletePicture: EventEmitter<void> = new EventEmitter();
  disableAddMenu = false;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    public appService: AppService,
  ) {
  }

  ngOnInit() {
  }

  deletePicture(id) {
    this.onDeletePicture.emit(id);
  }

  deleteLocation() {
    this.form?.get('latitude').setValue(null);
    this.form?.get('longitude').setValue(null);
    this.form?.get('location').setValue(null);
    this.form?.get('station_range').setValue(null);
  }

  showLocationSection() {
    const hasGps = this.form?.controls?.latitude?.value !== null &&
      this.form?.controls?.longitude?.value !== null &&
      this.form?.controls?.latitude?.value !== '' &&
      this.form?.controls?.longitude?.value !== '';

    return hasGps || !!this.form?.controls?.location?.value || !!this.form?.controls?.station_range?.value;
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
